/**
 *
 * @param {String} input
 * @returns
 */
const getStringParts = (input = "") => {
  if (input.length < 3) {
    return input;
  }

  const first10 = input.substring(0, 10);

  const middleStart = Math.floor((input.length - 3) / 2);
  const middle3 = input.substring(middleStart, middleStart + 3);

  const last3 = input.substring(input.length - 10);

  return `${first10}-${middle3}-${last3}`;
};

export default getStringParts;